/* eslint-disable no-unused-vars */
export enum AppEnum {
    MGMT = 'MGMT',
    BOH = 'BOH',
    CARE_PLANNER = 'CARE_PLANNER',
}
